import React, { Component } from 'react'
import ReactTable from 'react-table'
import moment from 'moment'
import { Tooltip } from 'antd'
import { filterCaseInsensitive } from '../../../util'

class Notes extends Component {
  render() {
    const { contactNotes } = this.props
    return (
      <div>
        <div className="row">
          <div className="col-md-6">
            <h4>Notes</h4>
          </div>
        </div>
        <ReactTable
          data={contactNotes}
          filterable
          defaultFilterMethod={filterCaseInsensitive}
          columns={[
            {
              columns: [
                {
                  Header: 'Content',
                  id: 'content',
                  accessor: d => <Tooltip title={d.content}>{d.content}</Tooltip>
                },
                {
                  Header: 'Created Date',
                  id: 'created_date',
                  accessor: d => moment.utc(d.created_date).format('M/D/YYYY'),
                  minWidth: 70
                }
              ]
            }
          ]}
          defaultPageSize={5}
          className="-striped -highlight"
        />
      </div>
    )
  }
}

export default Notes



// WEBPACK FOOTER //
// ./src/components/jobs/contacts/Notes.js